import { gql } from '@apollo/client';

export const TOGGLE_USER_ACCESS = gql`
  mutation TOGGLE_USER_ACCESS($userId: Float!, $isBlocked: Boolean!) {
    toggleUserAccess(userId: $userId, isBlocked: $isBlocked) {
      id
      email
      isBlocked
    }
  }
`;